import { render, staticRenderFns } from "./HelloUser.vue?vue&type=template&id=36a02ea2&scoped=true&"
import script from "./HelloUser.ts?vue&type=script&lang=ts&"
export * from "./HelloUser.ts?vue&type=script&lang=ts&"
import style0 from "./HelloUser.vue?vue&type=style&index=0&id=36a02ea2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a02ea2",
  null
  
)

export default component.exports